import { useEffect, useState } from "react";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";

export default function Leadership() {
  const [directors, setDirectors] = useState([]);

  useEffect(() => {
    api.get("/directors").then((r) => setDirectors(r.data)).catch(() => {});
  }, []);

  const chairman = directors.find((d) => d.order === 1);
  const rest = directors.filter((d) => d.order !== 1);

  return (
    <div data-testid="leadership-page" className="pt-28 sm:pt-36">
      <SEO title="Leadership" description="The leadership of RK Group — Founder & Chairman Ramesh Chand Kapoor and the directors of the Kapoor family." />
      <header className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-16">
        <Eyebrow>Leadership</Eyebrow>
        <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4 leading-[1.05]">
          Leadership Across <span className="italic text-[#C5A059]">Generations</span>
        </h1>
      </header>

      {chairman && (
        <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-20">
          <Reveal className="grid grid-cols-1 lg:grid-cols-12 border border-[#C5A059]/25 bg-[#0B1320]">
            <div className="lg:col-span-4 relative bg-[#060A12] flex items-center justify-center p-16 min-h-[360px] overflow-hidden">
              {chairman.image ? (
                <img src={chairman.image} alt={chairman.name} data-testid="chairman-portrait"
                  className="absolute inset-0 w-full h-full object-cover object-top" />
              ) : (
                <div className="w-32 h-32 mx-auto rounded-full border border-[#C5A059]/50 flex items-center justify-center">
                  <span className="font-serif text-5xl text-[#C5A059]">RK</span>
                </div>
              )}
            </div>
            <div className="lg:col-span-8 p-8 sm:p-14">
              <Eyebrow>Founder &amp; Chairman</Eyebrow>
              <h2 className="font-serif text-4xl sm:text-5xl text-[#FBF9F5] mt-3">{chairman.name}</h2>
              <p className="text-base text-[#94A3B8] leading-loose mt-6 max-w-2xl">{chairman.bio}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-10">
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">Responsibilities</p>
                  <p className="text-sm text-[#94A3B8] leading-relaxed">{chairman.responsibilities}</p>
                </div>
                <div>
                  <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">Current Focus</p>
                  <p className="text-sm text-[#94A3B8] leading-relaxed">{chairman.focus}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </section>
      )}

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {rest.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.06} className="border border-white/10 p-8 sm:p-12 hover:border-[#C5A059]/40 transition-colors duration-500">
              <div className="flex items-center gap-6">
                {d.image ? (
                  <img src={d.image} alt={d.name}
                    className="w-20 h-20 rounded-full object-cover object-top border border-[#C5A059]/40 shrink-0" />
                ) : (
                  <div className="w-20 h-20 rounded-full border border-[#C5A059]/40 flex items-center justify-center shrink-0 bg-[#0B1320]">
                    <span className="font-serif text-2xl text-[#C5A059]">
                      {d.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                    </span>
                  </div>
                )}
                <div>
                  <h3 className="font-serif text-2xl sm:text-3xl text-[#FBF9F5]">{d.name}</h3>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-[#94A3B8] mt-1">{d.role}</p>
                </div>
              </div>
              <p className="text-sm text-[#94A3B8] leading-loose mt-6">{d.bio}</p>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
                <div>
                  <p className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-2">Responsibilities</p>
                  <p className="text-[#94A3B8]">{d.responsibilities}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-2">Focus</p>
                  <p className="text-[#94A3B8]">{d.focus}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
